import Model from "./base/model";

class nfPdfFile extends Model{
    resourceName() {
        return "nf_pdf_files";
    }

    fields() {
        return {
          path: "",
          name: "",
          checked: "",
          is_additional: "",
        }
    }
}

export default new nfPdfFile();
